// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminChatController from "./admin_chat_controller"
application.register("admin-chat", AdminChatController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AdminReservationCalendarController from "./admin_reservation_calendar_controller"
application.register("admin-reservation-calendar", AdminReservationCalendarController)

import AdminTableController from "./admin_table_controller"
application.register("admin-table", AdminTableController)

import BlockFormController from "./block_form_controller"
application.register("block-form", BlockFormController)

import ComboMenuController from "./combo_menu_controller"
application.register("combo-menu", ComboMenuController)

import BodyMeasurementFormController from "./body_measurement_form_controller"
application.register("body-measurement-form", BodyMeasurementFormController)

import BulkMessageFormController from "./bulk_message_form_controller"
application.register("bulk-message-form", BulkMessageFormController)

import DailyCalendarController from "./daily_calendar_controller"
application.register("daily-calendar", DailyCalendarController)

import DateInputController from "./date_input_controller"
application.register("date-input", DateInputController)

import ExtensionToggleController from "./extension_toggle_controller"
application.register("extension-toggle", ExtensionToggleController)

import KatakanaValidationController from "./katakana_validation_controller"
application.register("katakana-validation", KatakanaValidationController)

import MeasurementTypeController from "./measurement_type_controller"
application.register("measurement-type", MeasurementTypeController)

import DebounceSubmitController from "./debounce_submit_controller"
application.register("debounce-submit", DebounceSubmitController)

import MessageTemplateTableController from "./message_template_table_controller"
application.register("message-template-table", MessageTemplateTableController)

import MobileTabsController from "./mobile_tabs_controller"
application.register("mobile-tabs", MobileTabsController)

import NoHyphenInputController from "./no_hyphen_input_controller"
application.register("no-hyphen-input", NoHyphenInputController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PlanSubscriptionController from "./plan_subscription_controller"
application.register("plan-subscription", PlanSubscriptionController)

import PostalCodeController from "./postal_code_controller"
application.register("postal-code", PostalCodeController)

import PurchaseHistoryFormController from "./purchase_history_form_controller"
application.register("purchase-history-form", PurchaseHistoryFormController)

import ReservationDetailPopoverController from "./reservation_detail_popover_controller"
application.register("reservation-detail-popover", ReservationDetailPopoverController)

import ReservationFormController from "./reservation_form_controller"
application.register("reservation-form", ReservationFormController)

import ReservationModalController from "./reservation_modal_controller"
application.register("reservation-modal", ReservationModalController)

import SlotSelectionController from "./slot_selection_controller"
application.register("slot-selection", SlotSelectionController)

import TicketPaymentController from "./ticket_payment_controller"
application.register("ticket-payment", TicketPaymentController)

import TrainingRecordFormController from "./training_record_form_controller"
application.register("training-record-form", TrainingRecordFormController)

